export const nbMoment = {
  months: [
    'Januar',
    'Februar',
    'Mars',
    'April',
    'Mai',
    'Juni',
    'Juli',
    'August',
    'September',
    'Oktober',
    'November',
    'Desember'
  ],
  // Lowercase, as Norwegian writes them, and without a dot: deadlineDateFormat adds one (#229).
  monthsShort: ['jan', 'feb', 'mar', 'apr', 'mai', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'des'],
  relativeTime: {
    future: 'i %s',
    past: '%s siden',
    m: '%d minutt',
    mm: '%d minutter',
    s: '%d sekund',
    ss: '%d sekunder',
    h: 'en time',
    hh: '%d timer',
    d: 'en dag',
    dd: '%d dager',
    M: 'en måned',
    MM: '%d måneder',
    y: 'et år',
    yy: '%d år'
  }
};
